import request from "../Requests/requests";
export const editTodo = (payload) => {
  return async dispatch => {
    await request.put('/Task/Update', {
      taskId: payload.id,
      userId: payload.userId,
      title: payload.title !== null ? payload.title.replace(/(<([^>]+)>)/gi, '') : payload.title,
      description: payload.description !== null ? payload.description : payload.description,
      priority: payload.priority,
      hours: payload.hours,
      minutes: payload.minutes,
      date: payload.date,
      time: payload.time,
      tagsId: payload.tags?.map((tag) => tag.tagId),
      isRepit: payload.isRepit,
      isOpened: payload.isOpened,
      repitPeriod: payload.repitPeriod ?? null,
      templateTime: payload.templateTime ?? '',
      intervalType: payload.intervalType ?? 0,
      interval: payload.interval ?? 1,
      selectedWeekDays: payload.selectedWeekDays ?? null,
      selectedMonthDays: payload.selectedMonthDays ?? null,
      endType: payload.endType ?? 0,
      dateEnd: payload.dateEnd ?? '',
      repitCount: payload.repitCount ?? 1,
      isCreatedAfterCompited: payload.isCreatedAfterCompited ?? false,
      targetOfAction: payload.targetOfAction ?? 0,
      notificationType: payload.notificationType
    })
  }
}